import { EventsBySportIdRequest } from "sb-bff-integration";
import { ComponentType } from "../../data";
export const ComponentTypeMapper = {
    [EventsBySportIdRequest.EventTypesEnum.Fixture]: (isMiniCard) => getFixtureType(isMiniCard),
    [EventsBySportIdRequest.EventTypesEnum.Outright]: (isMiniCard, isLive) => getOutrightType(isLive, isMiniCard),
    [EventsBySportIdRequest.EventTypesEnum.AggregateFixture]: (isMiniCard) => ComponentType.AggregateCard
};
const getFixtureType = (isMiniCard) => {
    return isMiniCard
        ? ComponentType.MiniEventCard
        : ComponentType.EventCard;
};
const getOutrightType = (eventIsLive, isMiniCard) => {
    if (!eventIsLive) {
        return ComponentType.PreLiveOutright;
    }
    return isMiniCard
        ? ComponentType.MiniOutright
        : ComponentType.LiveOutright;
};
//# sourceMappingURL=ComponentTypeMapper.js.map